import api from '@/apis'
import * as TYPES from './mutationTypes'

export default {
  getNodeManageLists({ commit }, params) {
    return api.node
      .getNodeManageList(params)
      .then(response => response.data)
      .then(result => {
        commit(TYPES.GET_NODE_MANAGE, {
          result,
          params
        })
        return result
      })
      .catch(error => Promise.reject(error))
  }
}
